var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26795 0 0 6.26795 0 14C0 21.732 6.26795 28 14 28C21.732 28 28 21.732 28 14C28 6.26795 21.732 0 14 0Z",
    fill: "#005BBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8122 8.0532L18.3116 20.6607C18.3116 20.6607 17.9619 21.5351 17.0002 21.1154L11.2298 16.6914L9.1315 15.6773L5.59935 14.4882C5.59935 14.4882 5.05729 14.2959 5.00479 13.8762C4.95229 13.4565 5.61685 13.2293 5.61685 13.2293L19.658 7.72114C19.658 7.72114 20.8121 7.21407 20.8121 8.05342",
    fill: "#F2F3F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7863 20.5188C10.7863 20.5188 10.6179 20.5031 10.4079 19.8385C10.1982 19.1741 9.13147 15.6769 9.13147 15.6769L17.6122 10.2913C17.6122 10.2913 18.1019 9.99402 18.0844 10.2913C18.0844 10.2913 18.1718 10.3438 17.9094 10.5886C17.6472 10.8335 11.2473 16.5863 11.2473 16.5863",
    fill: "#F1F2F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4423 18.3871L11.16 20.4681C11.16 20.4681 10.9815 20.6035 10.7864 20.5186L11.2234 16.6533",
    fill: "#4B769A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.1404bf321132d71da48d990d1e309971.svg";
export { ForwardRef as ReactComponent };